import React, { Component } from 'react';
import './CheckboxFilterOption.css';
import ParameterErrors from '../errors/ParameterErrors';
import Checkbox from './Checkbox';
import Once from '../core/Once';
const  {throwNotProvided, throwNotOfType} = ParameterErrors;
export default class CheckboxFilterOption extends Component {
	constructor(props){
		super(props)
		const {option, onChange}=props;
		this._inputCheckbox=React.createRef();
		if(!onChange)throwNotProvided('onChange');
		this._callbackChange = onChange;
		if(!option)throwNotProvided('option');
		this.clear = this.clear.bind(this);
		this._option = option;
		this._toggleChecked = this._toggleChecked.bind(this);
		/*this._handleInputCheckboxChange = this._handleInputCheckboxChange.bind(this);*/
		this._handleClick = this._handleClick.bind(this);
		this._handleClickOnce = this._handleClickOnce.bind(this);
		this._onceHandleClick = new Once(this._handleClickOnce);
		this.state={isChecked:false};
	}
	get valueString(){
		return this._option.valueString;
	}
	get option(){
		return this._option;
	}
	get value(){
		return this._option.value;
	}
	clear(){
		this._inputCheckbox.current.checked=false;
		this.setState({isChecked:false});
	}
	get isChecked(){
		return this._inputCheckbox.current.checked;
	}
	set isChecked(value){
		if(typeof(value) !== "boolean")
			throwNotOfType('value', 'boolean');
		this.setState({isChecked:value});
		this._inputCheckbox.current.checked=value;
	}
	_toggleChecked(){
		const isChecked =!this.state.isChecked;
		this.setState({isChecked:isChecked});
		this._inputCheckbox.current.checked=isChecked;
		this._callbackChange();
	}/*
	_handleInputCheckboxChange(e){
		this.state.isChecked = e.target.checked;
		this._callbackChange();
	}*/
	_handleClick(){
		this._onceHandleClick.trigger();
	}
	_handleClickOnce(){
		this._toggleChecked();
	}
	render() {
		let className ="checkbox-filter-option";
		if(this.state.isChecked)
			className+=" checked";
		const classNameOption = this._option.className;
		if(classNameOption)
			className+=` ${classNameOption}`;
		return (<div className={className} onClick={this._handleClick}>
			<Checkbox ref={this._inputCheckbox} text={this._option.text} toggleOnClick={false}/>
			</div>);	
	}
}
